// Generated from contracts/openapi.yaml and local references; do not edit.
export const JSON_RESPONSE_OPERATIONS = new Set<string>([
  "DELETE /admin-shared-memos/{kind}/{targetId}",
  "DELETE /admin/admin-users/{id}",
  "DELETE /admin/artist-invite-links/{token}",
  "DELETE /admin/event-notes/{id}",
  "DELETE /admin/group-chat-notes/{id}",
  "DELETE /admin/hold-casting-drafts/{draftId}",
  "DELETE /admin/nickname-permission",
  "DELETE /admin/personal-chat-notes/{id}",
  "DELETE /admin/pl/entries/{entryId}",
  "DELETE /admin/profile-picture",
  "DELETE /admin/read-receipts",
  "DELETE /admin/service-ai/artifacts/{artifactId}",
  "DELETE /admin/service-ai/sessions/{sessionId}",
  "DELETE /admin/service-ai/sessions/{sessionId}/attachments/{attachmentId}",
  "DELETE /admin/task-items/{taskId}/dependencies/{predecessorTaskId}",
  "DELETE /artist/event-notes/{id}",
  "DELETE /artist/external-invoice-presets/{presetId}",
  "DELETE /artist/external-invoices/{invoiceId}",
  "DELETE /artist/group-chat-notes/{id}",
  "DELETE /artist/group-members/{artistId}",
  "DELETE /artist/personal-chat-notes/{id}",
  "DELETE /artist/photos/{id}",
  "DELETE /artists/profile-picture",
  "DELETE /auth/google/admin/link",
  "DELETE /auth/google/artist/link",
  "DELETE /casting-templates/{templateUuid}",
  "DELETE /events/{eventUuid}",
  "DELETE /events/{eventUuid}/casting-templates/{templateUuid}",
  "DELETE /events/{eventUuid}/event-images",
  "DELETE /events/{eventUuid}/materials/{materialId}",
  "DELETE /events/{eventUuid}/playguide-sources/{sourceId}",
  "DELETE /events/{eventUuid}/timetables/{timetableId}",
  "DELETE /personal-memos/{kind}/{targetId}",
  "DELETE /ticket-sales/{statusId}",
  "DELETE /venues/{venueId}",
  "DELETE /venues/{venueId}/materials/{materialId}",
  "GET /admin-shared-memos/{kind}/{targetId}",
  "GET /admin/action-logs",
  "GET /admin/action-logs/analytics",
  "GET /admin/action-logs/observability",
  "GET /admin/admin-users",
  "GET /admin/admin-users/disabled",
  "GET /admin/admin-users/{id}/notification-settings",
  "GET /admin/admin-users/{id}/permissions",
  "GET /admin/admin-users/{id}/work-availability",
  "GET /admin/announcements",
  "GET /admin/announcements/pending-count",
  "GET /admin/approved-artists/{eventId}",
  "GET /admin/artist-chat/notify-mute/{artistId}",
  "GET /admin/artist-invite-links",
  "GET /admin/artist/{id}/bank-info",
  "GET /admin/artist/{id}/photos",
  "GET /admin/artists",
  "GET /admin/artists-with-parts",
  "GET /admin/artists-with-parts/one/{artistId}",
  "GET /admin/artists-with-parts/paged",
  "GET /admin/artists/{artistId}/ai-analysis",
  "GET /admin/artists/{artistId}/casting-reference",
  "GET /admin/artists/{artistId}/casting-reference/events",
  "GET /admin/artists/{artistId}/contracts",
  "GET /admin/artists/{artistId}/partner",
  "GET /admin/artists/{id}",
  "GET /admin/artists/{id}/deletion-preview",
  "GET /admin/artists/{id}/memberships",
  "GET /admin/casting-artist-selection",
  "GET /admin/casting-artist-selection/{artistId}/preview",
  "GET /admin/casting-artists",
  "GET /admin/casting-past-events",
  "GET /admin/chat-followups",
  "GET /admin/chat-followups/summary",
  "GET /admin/chat-mentions/admin-candidates",
  "GET /admin/chat-mentions/pending",
  "GET /admin/chat-mentions/pending-items",
  "GET /admin/concierge/applications",
  "GET /admin/concierge/pending-count",
  "GET /admin/contract-artists",
  "GET /admin/contract-artists/{contractArtistId}/document-revisions",
  "GET /admin/contract-clause-policy",
  "GET /admin/contract-clause-settings",
  "GET /admin/contract-detail/{contractArtistId}",
  "GET /admin/contract-drafts",
  "GET /admin/contract/common-affected-artists/{contractArtistId}",
  "GET /admin/contracts/badge-summary",
  "GET /admin/contracts/event/{eventUuid}/artist-status",
  "GET /admin/contracts/events/{eventUuid}/additional-reward-targets",
  "GET /admin/contracts/events/{eventUuid}/schedule-targets",
  "GET /admin/contracts/period",
  "GET /admin/contracts/upcoming",
  "GET /admin/contracts/{contractArtistId}/additional-reward-requests",
  "GET /admin/contracts/{contractArtistId}/supplemental-invoices",
  "GET /admin/contracts/{contractId}/prefill",
  "GET /admin/email-available",
  "GET /admin/event-chat/available-events/head",
  "GET /admin/event-chat/available-events/{offset}",
  "GET /admin/event-chat/events/{eventId}/reads/{messageId}",
  "GET /admin/event-chat/group-events/{eventId}",
  "GET /admin/event-chat/notify-mute/{eventId}",
  "GET /admin/event-chat/participants/{eventId}",
  "GET /admin/event-chat/representative-event/{threadId}",
  "GET /admin/event-chat/search",
  "GET /admin/event-chat/sidebar-row/{eventId}",
  "GET /admin/event-list",
  "GET /admin/event-marketing-templates",
  "GET /admin/event-notes/{id}",
  "GET /admin/events/assignment-admin-candidates",
  "GET /admin/events/{eventId}/casting-context",
  "GET /admin/events/{eventId}/casting-progress",
  "GET /admin/events/{eventId}/casting-workbench",
  "GET /admin/events/{eventId}/casting-workbench/artists/{artistId}/history",
  "GET /admin/events/{eventId}/fields/{field}",
  "GET /admin/events/{eventId}/participant-artists",
  "GET /admin/events/{eventId}/participant-finance-report",
  "GET /admin/events/{eventId}/partner-sharing",
  "GET /admin/events/{eventId}/rehearsal-extra",
  "GET /admin/events/{eventId}/stage-seating",
  "GET /admin/events/{eventUuid}/marketing",
  "GET /admin/events/{eventUuid}/marketing/initiatives/{initiativeId}/tasks",
  "GET /admin/events/{eventUuid}/marketing/reuse-sources",
  "GET /admin/events/{eventUuid}/marketing/task-placement-options",
  "GET /admin/events/{eventUuid}/pl/books",
  "GET /admin/events/{eventUuid}/survey-campaigns",
  "GET /admin/events/{eventUuid}/survey-campaigns/{campaignId}",
  "GET /admin/events/{eventUuid}/survey-campaigns/{campaignId}/aggregate",
  "GET /admin/events/{eventUuid}/survey-campaigns/{campaignId}/customer-link-candidates",
  "GET /admin/events/{eventUuid}/survey-campaigns/{campaignId}/export-jobs",
  "GET /admin/events/{eventUuid}/survey-campaigns/{campaignId}/responses",
  "GET /admin/events/{groupRootEventUuid}/chat-group-setting",
  "GET /admin/feature-flags",
  "GET /admin/finance",
  "GET /admin/finance/years",
  "GET /admin/genres",
  "GET /admin/genres/{genreId}/casting-reference-events",
  "GET /admin/global-search",
  "GET /admin/group-chat-notes/{id}",
  "GET /admin/group-chat/notify-mute/{threadId}",
  "GET /admin/group-chat/threads",
  "GET /admin/group-chat/threads/{threadId}",
  "GET /admin/group-chat/threads/{threadId}/announcements",
  "GET /admin/group-chat/threads/{threadId}/members",
  "GET /admin/group-chat/threads/{threadId}/messages/around/{messageId}/{before}/{after}",
  "GET /admin/group-chat/threads/{threadId}/messages/questions/{questionId}/responses",
  "GET /admin/group-chat/threads/{threadId}/messages/{offset}/{limit}",
  "GET /admin/group-chat/threads/{threadId}/reactions/{messageId}",
  "GET /admin/group-chat/threads/{threadId}/reads/{messageId}",
  "GET /admin/group-chat/unread-count",
  "GET /admin/hold-casting-detail/by-hold/{holdCastingId}",
  "GET /admin/hold-casting-detail/{holdCastingArtistId}",
  "GET /admin/hold-casting-drafts",
  "GET /admin/hold-casting/recent",
  "GET /admin/hold-requests/period",
  "GET /admin/hold-requests/upcoming",
  "GET /admin/invites",
  "GET /admin/invites/{token}",
  "GET /admin/invoices/{contractArtistId}/download-logs",
  "GET /admin/line/status",
  "GET /admin/manuals",
  "GET /admin/manuals/{slug}",
  "GET /admin/messages/bulk/event-candidates",
  "GET /admin/messages/latest/{artistId}",
  "GET /admin/messages/unread-count",
  "GET /admin/messages/{artistId}/announcements",
  "GET /admin/messages/{artistId}/around/{messageId}/{before}/{after}",
  "GET /admin/messages/{artistId}/before/{beforeCreatedAt}/{limit}",
  "GET /admin/messages/{artistId}/questions/{questionId}/responses",
  "GET /admin/messages/{artistId}/reactions/{messageId}",
  "GET /admin/messages/{artistId}/{offset}/{limit}",
  "GET /admin/mobile-release",
  "GET /admin/name/{adminUserId}",
  "GET /admin/new-messages/{artistId}/{lastCreatedAt}",
  "GET /admin/nickname-permissions/{artistId}",
  "GET /admin/notification-settings",
  "GET /admin/password-reset/{token}",
  "GET /admin/payments/monthly",
  "GET /admin/payments/monthly/badge-summary",
  "GET /admin/payments/undownloaded-months",
  "GET /admin/personal-chat-notes/{id}",
  "GET /admin/personal-chat/casting-events",
  "GET /admin/pl/books/{bookId}",
  "GET /admin/pl/books/{bookId}/breakdown/by-event",
  "GET /admin/pl/books/{bookId}/entries",
  "GET /admin/pl/books/{bookId}/summary",
  "GET /admin/playguide-connection-alerts",
  "GET /admin/playguide-connections",
  "GET /admin/playguide-connections/{connectionId}/acquired-performances",
  "GET /admin/playguide-organizations",
  "GET /admin/policies/{key}/history",
  "GET /admin/profile",
  "GET /admin/read-receipts/{artistId}",
  "GET /admin/service-ai/artifacts",
  "GET /admin/service-ai/goal-profiles",
  "GET /admin/service-ai/sessions",
  "GET /admin/service-ai/sessions/{sessionId}",
  "GET /admin/service-ai/sessions/{sessionId}/attachments",
  "GET /admin/service-ai/settings",
  "GET /admin/service-ai/settings/conversation-reviews",
  "GET /admin/service-ai/settings/conversation-reviews/{sessionId}",
  "GET /admin/service-ai/settings/usage",
  "GET /admin/service-ai/settings/usage-logs",
  "GET /admin/service-ai/settings/usage-logs/{usageEventId}",
  "GET /admin/service-ai/timetable-imports/{draftId}",
  "GET /admin/service-ai/usage",
  "GET /admin/surveys/campaign-sources",
  "GET /admin/surveys/survey-imports",
  "GET /admin/surveys/survey-imports/{importId}",
  "GET /admin/surveys/survey-imports/{importId}/customer-link-candidates",
  "GET /admin/surveys/survey-imports/{importId}/questionnaire-detections/latest",
  "GET /admin/surveys/survey-imports/{importId}/responses",
  "GET /admin/surveys/survey-imports/{importId}/summary",
  "GET /admin/surveys/survey-imports/{importId}/summary-versions",
  "GET /admin/surveys/templates",
  "GET /admin/task-items/{taskId}/attachments",
  "GET /admin/task-items/{taskId}/comments",
  "GET /admin/task-items/{taskId}/dependencies",
  "GET /admin/task-items/{taskId}/marketing-links",
  "GET /admin/task-projects/event/{eventUuid}/primary",
  "GET /admin/task-projects/mine",
  "GET /admin/task-projects/{projectId}",
  "GET /admin/task-projects/{projectId}/members",
  "GET /admin/task-projects/{projectId}/mention-candidates",
  "GET /admin/task-projects/{projectId}/saved-views",
  "GET /admin/task-templates",
  "GET /admin/task-templates/{templateId}",
  "GET /admin/tasks/summary",
  "GET /admin/timetables/active",
  "GET /admin/user/{id}",
  "GET /admin/username-available",
  "GET /admin/work-availability",
  "GET /admin/work-availability/people",
  "GET /admin/work-availability/status",
  "GET /announcements/feed",
  "GET /artist-groups",
  "GET /artist-invite/{token}",
  "GET /artist-password-reset/{token}",
  "GET /artist/auth/session",
  "GET /artist/bank-info",
  "GET /artist/chat-mentions/admin-candidates",
  "GET /artist/chat-mentions/pending",
  "GET /artist/chat-mentions/pending-items",
  "GET /artist/chat-questions/pending",
  "GET /artist/concierge/applications/by-token/{token}",
  "GET /artist/concierge/dashboard",
  "GET /artist/contract-count",
  "GET /artist/contract-detail/{contractArtistId}",
  "GET /artist/contracts",
  "GET /artist/contracts/period",
  "GET /artist/contracts/{contractArtistId}/additional-reward-requests",
  "GET /artist/contracts/{contractArtistId}/supplemental-invoices",
  "GET /artist/contracts/{contractId}",
  "GET /artist/deletion-policy",
  "GET /artist/email-available",
  "GET /artist/email-change/status",
  "GET /artist/event-chat/available-events/head",
  "GET /artist/event-chat/available-events/{offset}",
  "GET /artist/event-chat/group-events/{eventId}",
  "GET /artist/event-chat/participants/{eventId}",
  "GET /artist/event-chat/representative-event/{threadId}",
  "GET /artist/event-chat/search",
  "GET /artist/event-chat/sidebar-row/{eventId}",
  "GET /artist/event-notes/{id}",
  "GET /artist/events/calendar-summary",
  "GET /artist/events/filter-by-date",
  "GET /artist/events/upcoming",
  "GET /artist/events/{eventId}/partner-casting",
  "GET /artist/events/{eventUuid}/guest-tickets",
  "GET /artist/events/{eventUuid}/ticket-sales/share-announcements",
  "GET /artist/events/{eventUuid}/ticket-sales/shared",
  "GET /artist/external-invoice-presets",
  "GET /artist/group-chat-notes/{id}",
  "GET /artist/group-chat/threads",
  "GET /artist/group-chat/threads/{threadId}",
  "GET /artist/group-chat/threads/{threadId}/announcements",
  "GET /artist/group-chat/threads/{threadId}/messages/around/{messageId}/{before}/{after}",
  "GET /artist/group-chat/threads/{threadId}/messages/{offset}/{limit}",
  "GET /artist/group-chat/threads/{threadId}/reactions/{messageId}",
  "GET /artist/group-chat/unread-count",
  "GET /artist/group-members",
  "GET /artist/group-members/search",
  "GET /artist/guest-ticket-announcements",
  "GET /artist/hold-castings",
  "GET /artist/manuals",
  "GET /artist/manuals/{slug}",
  "GET /artist/messages/announcements",
  "GET /artist/messages/around/{messageId}/{before}/{after}",
  "GET /artist/messages/before/{beforeCreatedAt}/{limit}",
  "GET /artist/messages/reactions/{messageId}",
  "GET /artist/messages/search",
  "GET /artist/messages/unread-count",
  "GET /artist/messages/{offset}/{limit}",
  "GET /artist/new-messages/{lastCreatedAt}",
  "GET /artist/notification-pref",
  "GET /artist/offer-count",
  "GET /artist/offer-details/{holdCastingId}",
  "GET /artist/onboarding/status",
  "GET /artist/personal-chat-notes/{id}",
  "GET /artist/photos",
  "GET /artist/profile/ai-variants/status",
  "GET /artist/profile/me",
  "GET /artist/rewards",
  "GET /artist/rewards/years",
  "GET /artist/timetables/active",
  "GET /artists/{id}",
  "GET /auth/google/admin/link",
  "GET /auth/google/artist/link",
  "GET /bug-reports",
  "GET /bug-reports/status",
  "GET /casting-templates",
  "GET /casting-templates/{templateUuid}",
  "GET /chat/topics",
  "GET /chat/topics/events",
  "GET /chat/topics/message",
  "GET /common/events/{eventId}/casting-info",
  "GET /common/events/{eventId}/casting-overview",
  "GET /common/events/{eventId}/casting-progress",
  "GET /common/events/{eventId}/casting-summary",
  "GET /common/offer-change-logs/{holdCastingId}",
  "GET /contracts/{contractArtistId}/invoice/debug",
  "GET /csrf-token",
  "GET /event-chat/events/{eventId}/announcements",
  "GET /event-chat/events/{eventId}/messages/around/{messageId}/{before}/{after}",
  "GET /event-chat/events/{eventId}/messages/before/{beforeCreatedAt}/{limit}",
  "GET /event-chat/events/{eventId}/messages/new/{lastCreatedAt}",
  "GET /event-chat/events/{eventId}/messages/{offset}/{limit}",
  "GET /event-chat/events/{eventId}/reactions/{messageId}",
  "GET /event-chat/unread-counts/admin",
  "GET /event-chat/unread-counts/artist",
  "GET /event-notes/detail/{noteId}",
  "GET /events",
  "GET /events/by-uuids",
  "GET /events/calendar-summary",
  "GET /events/filter-by-date",
  "GET /events/first-upcoming",
  "GET /events/image-candidates",
  "GET /events/search",
  "GET /events/ticket-sales/overview",
  "GET /events/upcoming",
  "GET /events/{eventId}/hold-artists-statuses",
  "GET /events/{eventId}/messages/questions/{questionId}/responses",
  "GET /events/{eventUuid}",
  "GET /events/{eventUuid}/additional-dates",
  "GET /events/{eventUuid}/assignments",
  "GET /events/{eventUuid}/casting-templates",
  "GET /events/{eventUuid}/casting-templates/{templateUuid}",
  "GET /events/{eventUuid}/castings",
  "GET /events/{eventUuid}/deletion-check",
  "GET /events/{eventUuid}/group-events",
  "GET /events/{eventUuid}/guest-tickets",
  "GET /events/{eventUuid}/materials",
  "GET /events/{eventUuid}/parent-candidates",
  "GET /events/{eventUuid}/playguide-options",
  "GET /events/{eventUuid}/playguide-sources",
  "GET /events/{eventUuid}/playguide-sources/eplus/candidates",
  "GET /events/{eventUuid}/playguide-sources/lawson/candidates",
  "GET /events/{eventUuid}/playguide-sources/pia/candidates",
  "GET /events/{eventUuid}/ticket-sales",
  "GET /events/{eventUuid}/ticket-sales/marketing-timeline",
  "GET /events/{eventUuid}/ticket-sales/share-settings",
  "GET /events/{eventUuid}/ticket-sales/summary",
  "GET /events/{eventUuid}/ticket-setup",
  "GET /events/{eventUuid}/timetables",
  "GET /events/{eventUuid}/timetables/shared",
  "GET /events/{eventUuid}/timetables/{timetableId}",
  "GET /events/{eventUuid}/timetables/{timetableId}/runtime",
  "GET /genres",
  "GET /get-artist/{artistId}",
  "GET /group-chat-notes/detail/{noteId}",
  "GET /group-tags",
  "GET /line/ping",
  "GET /parts",
  "GET /personal-chat-notes/detail/{noteId}",
  "GET /personal-memos/{kind}/{targetId}",
  "GET /personal-memos/{kind}/{targetId}/revisions",
  "GET /playguide-options",
  "GET /policies/{key}",
  "GET /policies/{key}/history",
  "GET /public/concierge/status/{token}",
  "GET /public/flyers/highlights",
  "GET /public/surveys/{publicId}",
  "GET /public/surveys/{publicId}/session",
  "GET /reminders/event-chat/unread-reminders/preview",
  "GET /reminders/group-chat/unread-reminders/preview",
  "GET /reminders/normal-chat/unread-reminders/preview",
  "GET /reminders/reminders/schedules/{scheduleId}",
  "GET /reminders/schedules/{scheduleId}",
  "GET /session/admin",
  "GET /session/artist",
  "GET /storage/presign-get",
  "GET /storage/proxy-url",
  "GET /system/maintenance",
  "GET /system/mobile-release",
  "GET /templates",
  "GET /venue-genres",
  "GET /venuelist",
  "GET /venues/check-name",
  "GET /venues/check-name-advanced",
  "GET /venues/names",
  "GET /venues/{venueId}",
  "GET /venues/{venueId}/materials",
  "GET /venues/{venueId}/past-events",
  "GET /venues/{venueId}/pricings",
  "GET /work-availability/badges",
  "PATCH /admin/event-chat/participants/{eventId}/artists/{artistId}/chat-access",
  "PATCH /admin/events/{eventId}/casting-workbench/selection",
  "PATCH /admin/events/{eventUuid}/survey-campaigns/{campaignId}",
  "PATCH /admin/hold-casting/{holdCastingId}",
  "PATCH /admin/service-ai/sessions/{sessionId}",
  "PATCH /admin/service-ai/sessions/{sessionId}/action-previews/{actionId}",
  "PATCH /admin/service-ai/sessions/{sessionId}/artifacts/{artifactId}",
  "PATCH /admin/service-ai/settings/models/{featureKey}",
  "PATCH /admin/service-ai/settings/objective-profiles/{profileId}",
  "PATCH /admin/service-ai/settings/task-definitions/{definitionId}",
  "PATCH /admin/surveys/survey-imports/{importId}",
  "PATCH /artist/events/{eventUuid}/guest-tickets/registrations/{registrationId}",
  "PATCH /bug-reports/{bugId}/resolution",
  "PATCH /chat/topics/{topicId}",
  "PATCH /events/{eventUuid}/guest-tickets/registrations/{registrationId}",
  "PATCH /events/{eventUuid}/playguide-sources/{sourceId}/link-state",
  "PATCH /public/surveys/{publicId}/session",
  "POST /admin-login",
  "POST /admin-login/2fa",
  "POST /admin-logout",
  "POST /admin-shared-memos/summaries",
  "POST /admin/admin-users/{id}/restore",
  "POST /admin/admin-users/{id}/token-sessions/revoke",
  "POST /admin/artist-chat/notify-mute",
  "POST /admin/artist-invite-links",
  "POST /admin/artists/{artistId}/ai-analysis/corrections",
  "POST /admin/artists/{artistId}/ai-analysis/research-requests",
  "POST /admin/artists/{id}/ban-request",
  "POST /admin/artists/{id}/delete",
  "POST /admin/artists/{id}/unban",
  "POST /admin/casting-recommendations",
  "POST /admin/chat-followups/complete",
  "POST /admin/chat-followups/promote",
  "POST /admin/concierge/applications/{id}/approve",
  "POST /admin/concierge/applications/{id}/reject",
  "POST /admin/contract-clause-settings/defaults",
  "POST /admin/contract-clause-settings/defaults/reorder",
  "POST /admin/contract-clause-settings/defaults/{clauseKey}/publish",
  "POST /admin/contract-clause-settings/mandatory/publish",
  "POST /admin/contracts/additional-reward-items/{itemId}/decision",
  "POST /admin/contracts/additional-reward-requests/{requestId}/cancel",
  "POST /admin/contracts/events/{eventUuid}/additional-reward-offers",
  "POST /admin/contracts/events/{eventUuid}/schedule-batch",
  "POST /admin/contracts/{contractArtistId}/additional-reward-offers",
  "POST /admin/contracts/{contractArtistId}/finalize-revenue-share-reward",
  "POST /admin/contracts/{contractArtistId}/invoice-registration-review",
  "POST /admin/contracts/{contractArtistId}/no-response-invoice",
  "POST /admin/event-chat/notify-mute",
  "POST /admin/event-chat/participants/{eventId}/manual-artists",
  "POST /admin/event-marketing-templates",
  "POST /admin/event-notes",
  "POST /admin/events/{eventId}/casting-assign",
  "POST /admin/events/{eventId}/casting-assign-batch",
  "POST /admin/events/{eventId}/casting-assignment-save",
  "POST /admin/events/{eventId}/participant-finance-report/export",
  "POST /admin/events/{eventId}/stage-seating/text-projection",
  "POST /admin/events/{eventUuid}/cancel",
  "POST /admin/events/{eventUuid}/marketing/copy",
  "POST /admin/events/{eventUuid}/marketing/initiatives/{initiativeId}/tasks",
  "POST /admin/events/{eventUuid}/marketing/templates/{templateId}/apply",
  "POST /admin/events/{eventUuid}/pl/books",
  "POST /admin/events/{eventUuid}/pl/primary-book",
  "POST /admin/events/{eventUuid}/survey-campaigns",
  "POST /admin/events/{eventUuid}/survey-campaigns/{campaignId}/customer-link-candidates/{candidateId}/resolve",
  "POST /admin/events/{eventUuid}/survey-campaigns/{campaignId}/distributions",
  "POST /admin/events/{eventUuid}/survey-campaigns/{campaignId}/export-jobs",
  "POST /admin/events/{eventUuid}/survey-campaigns/{campaignId}/form-versions",
  "POST /admin/events/{eventUuid}/survey-campaigns/{campaignId}/form-versions/{formVersionId}/publish",
  "POST /admin/events/{groupRootEventUuid}/chat-group-setting/preview",
  "POST /admin/forgot-password",
  "POST /admin/group-chat-notes",
  "POST /admin/group-chat/threads",
  "POST /admin/group-chat/threads/{threadId}/messages/questions",
  "POST /admin/hold-casting-drafts",
  "POST /admin/hold-casting/decline",
  "POST /admin/hold-casting/latest-by-events",
  "POST /admin/hold-casting/mark-contract-sent",
  "POST /admin/hold-casting/{holdCastingId}/resend",
  "POST /admin/invites",
  "POST /admin/invites/{token}/complete",
  "POST /admin/messages/bulk/batch",
  "POST /admin/messages/bulk/text",
  "POST /admin/messages/files",
  "POST /admin/messages/images",
  "POST /admin/messages/text",
  "POST /admin/messages/{artistId}/questions",
  "POST /admin/nickname-permission",
  "POST /admin/notification-pref",
  "POST /admin/password-reset/{token}",
  "POST /admin/personal-chat-notes",
  "POST /admin/pl/books/{bookId}/entries",
  "POST /admin/pl/books/{bookId}/finalize",
  "POST /admin/pl/books/{bookId}/lock",
  "POST /admin/pl/books/{bookId}/recalculate",
  "POST /admin/pl/refresh-auto",
  "POST /admin/playguide-connections",
  "POST /admin/playguide-connections/{connectionId}/initial-sync",
  "POST /admin/playguide-connections/{connectionId}/test",
  "POST /admin/playguide-organizations",
  "POST /admin/quick-tasks",
  "POST /admin/read-receipts",
  "POST /admin/register-artist",
  "POST /admin/service-ai/sessions",
  "POST /admin/service-ai/sessions/{sessionId}/artifacts/{artifactId}/versions",
  "POST /admin/service-ai/sessions/{sessionId}/attachments",
  "POST /admin/service-ai/sessions/{sessionId}/feedback",
  "POST /admin/service-ai/sessions/{sessionId}/images",
  "POST /admin/service-ai/sessions/{sessionId}/messages",
  "POST /admin/service-ai/settings/objective-profiles",
  "POST /admin/service-ai/settings/task-definitions",
  "POST /admin/service-ai/timetable-imports/{draftId}/apply",
  "POST /admin/service-ai/timetable-imports/{draftId}/reject",
  "POST /admin/submit-contract",
  "POST /admin/surveys/survey-imports",
  "POST /admin/surveys/survey-imports/{importId}/questionnaire-detections",
  "POST /admin/surveys/survey-imports/{importId}/questionnaire-versions/confirm",
  "POST /admin/surveys/survey-imports/{importId}/source-files",
  "POST /admin/surveys/templates",
  "POST /admin/task-items/{taskId}/attachments",
  "POST /admin/task-items/{taskId}/comments",
  "POST /admin/task-projects/import/asana-csv",
  "POST /admin/task-projects/{projectId}/import/asana-csv",
  "POST /admin/task-projects/{projectId}/sections/reorder",
  "POST /admin/upload-temp",
  "POST /admin/venues/recalc-stats",
  "POST /admin/work-availability/daily-prompt/acknowledge",
  "POST /admin/work-availability/daily-prompt/claim",
  "POST /admin/work-availability/daily-prompt/reserve",
  "POST /admin/work-availability/entries",
  "POST /admin/work-availability/entries/batch",
  "POST /announcements/dismiss",
  "POST /announcements/{id}/acknowledge",
  "POST /artist-invite/{token}/request-link",
  "POST /artist-login",
  "POST /artist-logout",
  "POST /artist-password-reset/request",
  "POST /artist-password-reset/{token}",
  "POST /artist/account-type/switch",
  "POST /artist/additional-reward-items/{itemId}/receipt",
  "POST /artist/additional-reward-requests/{requestId}/cancel",
  "POST /artist/additional-reward-requests/{requestId}/respond",
  "POST /artist/additional-reward-requests/{requestId}/submit",
  "POST /artist/chat-questions/{questionId}/responses",
  "POST /artist/concierge/applications",
  "POST /artist/concierge/applications/by-token/{token}/create-event",
  "POST /artist/contracts/{contractArtistId}/additional-reward-claims",
  "POST /artist/contracts/{contractArtistId}/confirm-invoice",
  "POST /artist/email-change/confirm",
  "POST /artist/email-change/request",
  "POST /artist/event-notes",
  "POST /artist/events/{eventUuid}/guest-tickets/registrations",
  "POST /artist/events/{eventUuid}/guest-tickets/registrations/{registrationId}/cancel",
  "POST /artist/external-invoice-presets",
  "POST /artist/external-invoices",
  "POST /artist/group-chat-notes",
  "POST /artist/group-members",
  "POST /artist/messages/files",
  "POST /artist/messages/text",
  "POST /artist/notification-pref",
  "POST /artist/personal-chat-notes",
  "POST /artist/photos",
  "POST /artist/profile/ai-variants",
  "POST /artist/request-delete",
  "POST /artist/respond-offer",
  "POST /artist/supplemental-invoices/{supplementalInvoiceId}/confirm-invoice",
  "POST /auth/google/admin/link",
  "POST /auth/google/artist/link",
  "POST /auth/google/login",
  "POST /auth/token",
  "POST /auth/token/refresh",
  "POST /auth/token/revoke",
  "POST /bug-reports",
  "POST /casting-templates",
  "POST /chat/topics/assignments",
  "POST /chat/topics/read",
  "POST /common/events/casting-summary",
  "POST /common/events/task-summary",
  "POST /content-moderation/reports",
  "POST /details",
  "POST /events",
  "POST /events/assignments/self",
  "POST /events/playguide-link-suggestions",
  "POST /events/{eventId}/messages/questions",
  "POST /events/{eventUuid}/casting-templates",
  "POST /events/{eventUuid}/casting-templates/{templateUuid}/apply",
  "POST /events/{eventUuid}/delete-flyer",
  "POST /events/{eventUuid}/guest-tickets/allocations",
  "POST /events/{eventUuid}/guest-tickets/allocations/all-participants",
  "POST /events/{eventUuid}/guest-tickets/announcements",
  "POST /events/{eventUuid}/guest-tickets/registrations",
  "POST /events/{eventUuid}/guest-tickets/registrations/{registrationId}/status",
  "POST /events/{eventUuid}/image-reference",
  "POST /events/{eventUuid}/manual-participants",
  "POST /events/{eventUuid}/materials",
  "POST /events/{eventUuid}/playguide-link-suggestions/dismiss",
  "POST /events/{eventUuid}/playguide-sources/eplus",
  "POST /events/{eventUuid}/playguide-sources/lawson",
  "POST /events/{eventUuid}/playguide-sources/pia",
  "POST /events/{eventUuid}/playguide-sources/sync",
  "POST /events/{eventUuid}/playguide-sources/teket",
  "POST /events/{eventUuid}/playguide-sources/teket/preview",
  "POST /events/{eventUuid}/playguide-sources/teket/search",
  "POST /events/{eventUuid}/playguide-sources/{sourceId}/sync",
  "POST /events/{eventUuid}/ticket-sales",
  "POST /events/{eventUuid}/ticket-sales/automatic-entries/{entryId}/control",
  "POST /events/{eventUuid}/timetable-announcements",
  "POST /events/{eventUuid}/timetables",
  "POST /events/{eventUuid}/timetables/{timetableId}/adjustments",
  "POST /events/{eventUuid}/timetables/{timetableId}/memos",
  "POST /events/{eventUuid}/timetables/{timetableId}/notify-artists",
  "POST /line/admin/link-code",
  "POST /line/admin/unlink",
  "POST /line/link-code",
  "POST /line/push/test",
  "POST /line/unlink",
  "POST /personal-memos/summaries",
  "POST /playguide-sources/eplus/candidates",
  "POST /playguide-sources/lawson/candidates",
  "POST /playguide-sources/pia/candidates",
  "POST /postmark/webhook",
  "POST /public/concierge/applications",
  "POST /public/surveys/{publicId}/sessions",
  "POST /public/surveys/{publicId}/submissions",
  "POST /reminders/event-chat/unread-reminders/run",
  "POST /reminders/group-chat/unread-reminders/run",
  "POST /reminders/normal-chat/unread-reminders/run",
  "POST /reminders/run/contract-pending-reminders-now",
  "POST /reminders/run/hold-pending-reminders-now",
  "POST /reminders/run/invoice-unsubmitted-reminders-now",
  "POST /reminders/run/pending-registration-reminders-now",
  "POST /reminders/run/unread-reminders-now",
  "POST /setup-artist-full/{artistId}",
  "POST /setup-artist/{artistId}",
  "POST /storage/event-images/upload",
  "POST /storage/materials/presign-put",
  "POST /storage/materials/upload",
  "POST /storage/note-images/upload",
  "POST /storage/presign-get",
  "POST /storage/presign-put",
  "POST /venues",
  "POST /venues/{venueId}/materials",
  "PUT /admin-shared-memos/{kind}/{targetId}",
  "PUT /admin/admin-users/{id}/email",
  "PUT /admin/admin-users/{id}/notification-settings",
  "PUT /admin/artists/{artistId}/partner",
  "PUT /admin/event-marketing-templates/{templateId}",
  "PUT /admin/event-notes/{id}",
  "PUT /admin/events/{eventId}/casting-context",
  "PUT /admin/events/{eventId}/casting-workbench/artists/{artistId}",
  "PUT /admin/events/{eventId}/fields/{field}",
  "PUT /admin/events/{eventId}/partner-sharing",
  "PUT /admin/events/{eventId}/rehearsal-extra",
  "PUT /admin/events/{eventUuid}/basic-info",
  "PUT /admin/events/{eventUuid}/casts",
  "PUT /admin/events/{eventUuid}/commercial-structure",
  "PUT /admin/events/{eventUuid}/marketing",
  "PUT /admin/events/{eventUuid}/publication",
  "PUT /admin/genres/{genreId}/casting-axis-profile",
  "PUT /admin/group-chat-notes/{id}",
  "PUT /admin/mobile-release",
  "PUT /admin/notification-settings",
  "PUT /admin/notification-settings/macos-push",
  "PUT /admin/personal-chat-notes/{id}",
  "PUT /admin/pl/books/{bookId}/events/{eventUuid}",
  "PUT /admin/pl/entries/{entryId}",
  "PUT /admin/playguide-connections/{connectionId}",
  "PUT /admin/playguide-connections/{connectionId}/credentials",
  "PUT /admin/playguide-organizations/{organizationId}",
  "PUT /admin/policies/{key}",
  "PUT /admin/profile",
  "PUT /admin/profile-picture",
  "PUT /admin/profile/full-name",
  "PUT /admin/service-ai/settings/budgets/organization",
  "PUT /admin/service-ai/settings/budgets/users/{adminUserId}",
  "PUT /admin/work-availability/entries/{entryId}",
  "PUT /admin/work-availability/settings",
  "PUT /admin/work-availability/status",
  "PUT /artist/bank-info",
  "PUT /artist/event-notes/{id}",
  "PUT /artist/external-invoice-presets/{presetId}",
  "PUT /artist/group-chat-notes/{id}",
  "PUT /artist/personal-chat-notes/{id}",
  "PUT /artist/photos/{id}/comment",
  "PUT /artists/profile",
  "PUT /artists/profile-picture",
  "PUT /chat/topics/{topicId}/visibility",
  "PUT /events/{eventUuid}",
  "PUT /events/{eventUuid}/assignments",
  "PUT /events/{eventUuid}/castings",
  "PUT /events/{eventUuid}/guest-tickets/settings",
  "PUT /events/{eventUuid}/materials/{materialId}",
  "PUT /events/{eventUuid}/playguide-sources/{sourceId}/schedule",
  "PUT /events/{eventUuid}/playguide-sources/{sourceId}/ticket-mappings",
  "PUT /events/{eventUuid}/ticket-sales",
  "PUT /events/{eventUuid}/ticket-sales/share-settings",
  "PUT /events/{eventUuid}/ticket-setup",
  "PUT /events/{eventUuid}/timetables/{timetableId}",
  "PUT /personal-memos/{kind}/{targetId}",
  "PUT /ticket-sales/{statusId}",
  "PUT /venues/{venueId}",
  "PUT /venues/{venueId}/materials/{materialId}",
  "PUT /venues/{venueId}/pricings"
]);
